import { getCookie, setCookie, type CookieOptions } from './cookies';
import { getExpirationTime, uuidv4 } from './utils';

const ONE_HOUR_IN_MS = 60 * 60 * 1000;

export const setSessionId = (domain: string): void => {
	const sessionId = getCookie('dmp_session_id');
	const lastActivitySeen = getCookie('dmp_last_activity_seen');

	handleLastActivity(lastActivitySeen, sessionId, domain);
};

export const handleLastActivity = (
	lastActivitySeen: string | null,
	sessionId: string | null,
	domain: string
): void => {
	const elapsedMs = calculateElapsedMilliseconds(lastActivitySeen);
	const durationMs = Math.max(0, elapsedMs ?? 0);

	setCookie('dmp_event_duration', durationMs.toString());

	const shouldRotateSession =
		!sessionId || (elapsedMs !== null && elapsedMs > ONE_HOUR_IN_MS);

	if (shouldRotateSession) {
		setNewSessionId(domain);
	}
};

export const setNewSessionId = (domain: string): void => {
	const expirationTime = getExpirationTime(4);
	const cookieOptions = createSessionCookieOptions(domain, expirationTime);

	setCookie('dmp_session_id', uuidv4(), cookieOptions);
};

const calculateElapsedMilliseconds = (
	lastActivitySeen: string | null
): number | null => {
	if (!lastActivitySeen) {
		return null;
	}

	const lastActivity = new Date(lastActivitySeen);
	const lastActivityTimestamp = lastActivity.getTime();

	if (Number.isNaN(lastActivityTimestamp)) {
		return null;
	}

	return Date.now() - lastActivityTimestamp;
};

const createSessionCookieOptions = (
	domain: string,
	expires: Date
): CookieOptions => {
	const trimmedDomain = domain.trim();

	const options: CookieOptions = {
		secure: true,
		expires,
	};

	if (trimmedDomain) {
		options.domain = trimmedDomain;
	}

	return options;
};
